import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Link, Redirect } from "react-router-dom";

import * as ActionTypes from '../actions';

import Button from '../components/Button';
import Card from '../components/Card';
import CardTitle from '../components/CardTitle';
import CardText from '../components/CardText';
import Heading from '../components/Heading';
import LoadingSpinner from '../components/LoadingSpinner';
import MediaIcon from '../components/MediaIcon';
import Pagination from '../components/Pagination';
import PaginationPrev from '../components/PaginationPrev';
import PaginationNext from '../components/PaginationNext';

import CartItem from './CartItem';
import Legend from "../components/Legend";
import Fieldset from "../components/Fieldset";

const mapStateToProps = (state) => {
    return {
        items: state.items,
        data: state.data,
        isLoading: state.isLoading
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        processOrder: () => dispatch(ActionTypes.processOrder())
    };
};

class Summary extends Component {

    constructor(props) {
        super(props);
        this.inputRefs = [];

        this.state = {
            isValidated: false,
            isSubmitted: false,
            isDataProtectionAccepted: false,
            isTermsAndConditionsAccepted: false
        };
    }

    validate = () => {
        let isValidated = true;

        /*
        for (const [key, value] of Object.entries(this.inputRefs)) {
            if (value.required) {
                if (value.value) {
                    value.classList.remove('is-invalid');
                }
                else {
                    isValidated = false;
                    value.classList.add('is-invalid');
                }
            }
        }
        */

        this.setState({
            isValidated: isValidated,
            isSubmitted: true
        });

        return isValidated;
    }

    handleProcessOrder = event => {
        event.preventDefault();

        const isValidated = this.validate();

        if (isValidated) {
            this.props.processOrder();
        }
    }

    handleAcceptTermsAndConditionsChange = event => {
        this.setState({
            isTermsAndConditionsAccepted: event.target.checked
        })
    }

    handleAcceptDataProtectionChange = event => {
        this.setState({
            isDataProtectionAccepted: event.target.checked
        })
    }

    render() {
        const {items, data, isLoading} = this.props;
        const {isSubmitted, isValidated, isDataProtectionAccepted, isTermsAndConditionsAccepted} = this.state;

        let totalPrice = 0;
        Object.values(items).forEach(function(item) {
            if (item.properties.totalPrice) {
                totalPrice += item.properties.totalPrice * Object.keys(item.participants).length;
            }
        });

        if (totalPrice) {
            totalPrice = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(totalPrice);
        }

        return (
            <div>
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <div>
                        {isSubmitted && isValidated ? (
                            <Redirect to="/processing" />
                        ) : (
                            <div>
                                <Heading>Zusammenfassung</Heading>
                                {items && Object.entries(items).map(([key, value]) => (
                                    <CartItem key={key} item={value} />
                                ))}
                                <Card>
                                    <CardTitle>Rechnungsadresse</CardTitle>
                                    <CardText>
                                        {data.is_billed_to_company ?
                                            <p>
                                                <MediaIcon icon="user">
                                                    {data.bill_company && (
                                                        <div>
                                                            {data.bill_company}<br />
                                                        </div>
                                                    )}
                                                    {data.bill_street}<br />
                                                    {data.bill_zip} {data.bill_city}<br />
                                                </MediaIcon>
                                                <MediaIcon icon="phone">
                                                    {data.bill_phone}
                                                </MediaIcon>
                                                <MediaIcon icon="envelope">
                                                    {data.bill_emailAddress}
                                                </MediaIcon>
                                                {data.files && (
                                                    <MediaIcon icon="file">
                                                        <strong>Kostenübernahme-Formulare</strong>
                                                        <p>
                                                            {data.files ? Object.entries(data.files).map(([key, value]) => (
                                                                <div>{key}</div>
                                                            )) : (
                                                                <div>Keine Dateien hochgeladen</div>
                                                            )}
                                                        </p>
                                                    </MediaIcon>
                                                )}

                                            </p>
                                            : <p>
                                                Die Rechnung wird direkt an die Teilnehmer verschickt.
                                            </p>
                                        }
                                    </CardText>
                                </Card>
                                {(data.altContact_name || data.altContact_emailAddress || data.altContact_phone) && (
                                    <Card>
                                        <CardTitle>Ansprechpartner bei Rückfragen</CardTitle>
                                        <CardText>
                                            <MediaIcon icon="user">
                                                {data.altContact_name && (
                                                    <div>
                                                        {data.altContact_name}
                                                    </div>
                                                )}
                                                {data.bill_phone && (
                                                    <div>
                                                        {data.bill_phone}
                                                    </div>
                                                )}
                                                {data.altContact_emailAddress && (
                                                    <div>
                                                        {data.altContact_emailAddress}
                                                    </div>
                                                )}
                                            </MediaIcon>
                                        </CardText>
                                    </Card>
                                )}
                                {(data.more_generalInformation) && (
                                    <Card>
                                        <CardTitle>Weitere Informationen</CardTitle>
                                        <CardText>
                                            <MediaIcon icon="info-square">
                                                {data.more_generalInformation && (
                                                    <div>
                                                        {data.more_generalInformation}
                                                    </div>
                                                )}
                                            </MediaIcon>
                                        </CardText>
                                    </Card>
                                )}

                                <div class="mt-2 mb-3">
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input form-control"
                                                   name="acceptedDataProtection" id="cart_acceptedDataProtection"
                                                   onChange={this.handleAcceptDataProtectionChange}
                                            />
                                            <label class="custom-control-label" for="cart_acceptedDataProtection">Ich habe die <a href="/datenschutz" target="_blank">Datenschutzerklärung</a> der Bamberger Akademien für Gesundheits- und Pflegeberufe gelesen und akzeptiere diese. </label>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input form-control"
                                                   name="acceptedTermsAndConditions" id="cart_acceptedTermsAndConditions"
                                                   onChange={this.handleAcceptTermsAndConditionsChange}
                                            />
                                            <label class="custom-control-label" for="cart_acceptedTermsAndConditions">Ich habe die <a href="/agb" target="_blank">AGB</a> der Bamberger Akademien für Gesundheits- und Pflegeberufe gelesen und akzeptiere diese. </label>
                                        </div>
                                    </div>
                                </div>

                                <p class="text-right mb-3">
                                    Preis: <strong>{totalPrice}</strong> <br />
                                    <span class="small text-muted">Alle Angaben ohne Gewähr. Die genauen Kosten erhalten Sie von uns per E-Mail. </span>
                                </p>

                                <Pagination>
                                    <PaginationPrev>
                                        <Link to="/checkout" className="btn btn-gray">Zurück</Link>
                                    </PaginationPrev>
                                    <PaginationNext>
                                        <Button type="button" onClick={this.handleProcessOrder} disabled={!(isDataProtectionAccepted && isTermsAndConditionsAccepted)}>Verbindlich anmelden</Button>
                                    </PaginationNext>
                                </Pagination>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Summary);
